import { render, staticRenderFns } from "./NolaNovelIntroduction.vue?vue&type=template&id=2e04841f&scoped=true&"
import script from "./NolaNovelIntroduction.vue?vue&type=script&lang=ts&"
export * from "./NolaNovelIntroduction.vue?vue&type=script&lang=ts&"
import style0 from "./NolaNovelIntroduction.vue?vue&type=style&index=0&id=2e04841f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04841f",
  null
  
)

export default component.exports